export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1000px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">关于香香漫画</h2>
          <p className="text-sm md:text-base text-foreground-600">打造最懂漫画爱好者的阅读平台</p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-10 items-center">
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                香香漫画成立于2020年，是国内领先的免费漫画在线阅读平台。我们致力于为广大漫画爱好者提供香香漫画大全免费的优质阅读体验，涵盖热血、恋爱、悬疑、搞笑、玄幻、科幻等全品类漫画资源。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                作为香香漫画免费看的倡导者，我们率先推出了下拉式阅读模式，让用户可以像刷短视频一样流畅地追更漫画。香香漫画免费下拉功能打破了传统翻页阅读的限制，一部手机、一个手指，就能畅享沉浸式阅读。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                目前平台已收录超过10万部好看的漫画免费全集，每日持续更新热门连载。无论是经典老番还是热门新作，在香香漫画都能找到。我们坚持免费、高清、快速的核心理念，让每个人都能无门槛地享受漫画的乐趣。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                未来，香香漫画将持续优化阅读体验，引入更多优质漫画资源，打造国内最受欢迎的漫画阅读社区。感谢每一位读者的支持与陪伴！
              </p>
            </div>
            <div className="shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20artistic%20illustration%20of%20a%20cozy%20reading%20corner%2C%20stacks%20of%20colorful%20manga%20books%20on%20a%20wooden%20desk%2C%20soft%20window%20light%2C%20coral%20rose%20and%20golden%20amber%20warm%20tones%2C%20gentle%20watercolor%20ink%20artistic%20style%2C%20harmonious%20composition%2C%20editorial%20photography%20feel%2C%20high%20detail%2C%20inviting%20atmosphere&width=600&height=600&seq=about-manga-01&orientation=squarish"
                alt="香香漫画 - 关于我们品牌形象"
                className="w-full max-w-[260px] md:max-w-[300px] rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}